import React from 'react';
import {
  FDContentContainer,
} from '@facet-wealth/design';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import PropTypes from 'prop-types';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import metaOverrideSet from './metaOverrideSet';
import JobsSectionLayout from './JobsSectionLayout';

const JobsSection = ({ relationship }) => {
  const { pageContentCollection } = usePageContentContext();

  if (!relationship) {
    return null;
  }

  const resource = pageContentCollection
    .included()
    .findResource(relationship.data?.[0]);

  if (!resource) {
    return null;
  }

  if (!resource) {
    return null;
  }

  return (
    <FDContentContainer maxWidth="md">
      <MetaFormInline
        padding="none"
        noIndividualSubmitButtons
        resource={resource}
        layout={JobsSectionLayout}
        metaOverrideSet={metaOverrideSet}
      />
    </FDContentContainer>
  );
};

JobsSection.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default JobsSection;
